import React from 'react'
import { DcOverlaySlider } from 'pixel-base'
import OrderDetails from '../OrderDetails/OrderDetails'
import SplitOrder from '../SplitAndMerge/SplitOrder'

interface Props {
  show: boolean
  SetShowOrderDetailModal: (show: boolean) => void
  orderId: string | null
  setOrderId: (id: string | null) => void
  newOrder: boolean
  setNewOrder: (isNew: boolean) => void
  filters: any
  splitOrder: { isSplit: boolean; splitId: string | null }
  setSplitOrder: (split: { isSplit: boolean; splitId: string | null }) => void
  setReload: (reload: boolean) => void
}

const OrderDetailsPanel: React.FC<Props> = ({
  show,
  SetShowOrderDetailModal,
  orderId,
  setOrderId,
  newOrder,
  setNewOrder,
  filters,
  splitOrder,
  setSplitOrder,
  setReload,
}) => {
  return (
    <DcOverlaySlider
      padding="0px"
      isOpen={show}
      onClose={() => {
        setNewOrder(false)
        setOrderId(null)
        SetShowOrderDetailModal(false)
        setSplitOrder({ isSplit: false, splitId: null })
      }}
      title={orderId == null ? 'Add New Order' : 'Order Detail'}
      width="70%"
    >
      {splitOrder.isSplit ? (
        <SplitOrder
          setSplitOrder={setSplitOrder}
          splitId={splitOrder.splitId}
          SetShowOrderDetailModal={SetShowOrderDetailModal}
          setReload={setReload}
        />
      ) : (
        <OrderDetails
          filters={filters}
          isNewOrder={newOrder}
          setIsNewOrder={setNewOrder}
          setOrderId={setOrderId}
          orderId={orderId}
          SetShowOrderDetailModal={SetShowOrderDetailModal}
          splitOrder={splitOrder}
          setSplitOrder={setSplitOrder}
          setReload={setReload}
        />
      )}
    </DcOverlaySlider>
  )
}

export default OrderDetailsPanel
